export default __webpack_public_path__ + "static/media/download-app.f3722dd2.png";